import { ChangeEvent, FormEvent } from 'react';

import { ISanityBlockContent, ISanityImage } from '@rbi-ctg/menu';
import { IGiftOffer } from 'generated/rbi-graphql';
import { IImageFragment } from 'generated/sanity-graphql';

export interface ISubmitGift {
  email: string;
  message: string;
  gift: string;
}

interface IGiftOptions {
  title: string;
  titleFormatted: string;
  offerId: string;
  costInPoints: number;
  eligible: boolean;
}

export interface ISendGiftViewProps {
  gift: string;
  email: string;
  name: string;
  message: string;
  image?: ISanityImage | IImageFragment | null;
  imageAlt: string;
  title?: string | null;
  textContent: ISanityBlockContent[] | null;
  giftOptions: IGiftOffer[];
  legalCopy: ISanityBlockContent[] | null;
  handleSubmit: (event: FormEvent) => void;
  userPoints?: number;
  handleChange: (
    e: ChangeEvent<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  errorEmailMessage: string;
  errorGiftMessage: string;
  errorNameMessage: string;
  isSendingEmail: boolean;
}

export enum INPUT_ID {
  GIFT = 'gift-input-id',
  EMAIL = 'email-input-id',
  MESSAGE = 'message-input-id',
  NAME = 'name-input-id',
}
